import { render, staticRenderFns } from "./PayoutsTable.vue?vue&type=template&id=cbc48872&"
import script from "./PayoutsTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsTable.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports